<template>
  <BaseAction>
    <PrimaryButton
      text
      @click.native="openDialog"
      :class="{ 'full-width': isMobile }"
    >
      + Add question
    </PrimaryButton>
    <AddApplicationQuestionDialog
      :title="title"
      @onAdd="onAdd"
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddApplicationQuestionDialog from "../dialogs/AddApplicationQuestionDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "AddApplicationQuestionAction",
  props: {
    title: { type: String, required: true }
  },
  components: {
    AddApplicationQuestionDialog,
    PrimaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    },
    onAdd(questionTemplate) {
      this.closeDialog();
      this.$emit("onAdd", questionTemplate);
    }
  }
};
</script>
